import React, { useEffect, useState, useTransition } from "react";
import userService from "../../../app/services/user.service";
import { useSearchParams } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../../assets/img/motion_new_logo.png";
import footer from "../../../assets/img/footer_icon.jpg";
import backImage from "../../../assets/img/back_page-0001.jpg";
import styles from "./Solution.module.css";
import Loader from "../../../UI/loader/loader";
import { isEmpty } from "../../../utils/custom_funtions";
import { uid } from "react-uid";
import useMathjax from "../../../hooks/useMathjax";
import SolutionComponent from "./SolutionComponent";
import footerImage from "../../../assets/img/footer1.jpg"

const ArrayTable = ({ data, info }) => {
  const chunkedData = [];
  for (let i = 0; i < data.length; i += 8) {
    chunkedData.push(data.slice(i, i + 8));
  }
  const optionMapping = {
    A: "(1)",
    B: "(2)",
    C: "(3)",
    D: "(4)",
    E: "(5)",
    F: "(6)",
  };

  return (
    <table className="table table-borderless">
      <tbody>
        {chunkedData.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((item, colIndex) => (
              <td className={styles.td} key={colIndex}>
                {item.display_number}.
                {info.center_id == 17 || info.target_id == 3
                  ? optionMapping[item.answer]
                  : item.answer}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const Solution = () => {
  const [searchParams] = useSearchParams();
  const [info, setInfo] = useState({});
  const [subjectArr, setSubjectArr] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  const [solutionData, setSolutionData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isPending, startTransition] = useTransition()
  const getSolition = () => {
    startTransition(() => {
      setLoading(true);
      userService
        .getPaperInfo(searchParams.get("paperid"))
        .then((res) => {


          const response = res.data.data;
          const datas = {
            ...response,
            // to_be_held_on: convertDate(res.data.data[0][0].to_be_held_on),
          };
          console.log(datas);
          document.title = `Solution_${datas.paperdetail.paper_name}_${datas.paperdetail.to_be_held_on}_${datas.paperdetail.center}`;
          setInfo(datas.paperdetail);
          // setQuesData(Object.values(res.data.data[0]))
          userService
            .getSolutons(
              searchParams.get("paperid"),
              "'" + datas.sub_sequence + "'"
            )
            .then((res) => {
              console.log(res.data.data);
              console.log(Object.values(res.data.data[0]));
              const solutionDatas = Object.values(res.data.data[0]);
              const subList = [...new Set(solutionDatas.map((x) => x.subject))];
              const sectionList = [
                ...new Set(solutionDatas.map((x) => x.section_name)),
              ];
              setSectionArr(sectionList);
              setSubjectArr(subList);
              console.log(subList);
              setSolutionData(solutionDatas);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    })

  };

  useEffect(() => {
    // const key = searchParams.get("key");
    // if (key == 0 || key == 1 || key == 2) {
    //   getAnswerKeys();
    // } else if (key == 3) {
    //   getQuestionMapping();
    // }
    getSolition();
  }, []);
  useMathjax(solutionData, isPending);


  const setPrintPageSize = (size) => {
    let style = document.getElementById("dynamic-print-page-size");

    if (!style) {
      style = document.createElement("style");
      style.id = "dynamic-print-page-size";
      document.head.appendChild(style);
    }

    style.innerHTML = `
      @media print {
        @page {
          size: ${size};
          margin: .5in .5in .7in .5in; 
          
        }
      }
    `;
  };

  useEffect(() => {
    // Bulk Question Request size
    setPrintPageSize("8.5in 11.7in");

    return () => {
      // Cleanup when leaving page
      const style = document.getElementById("dynamic-print-page-size");
      if (style) style.remove();
    };
  }, []);

  // When number_sequence === 3, numbering should be continuous per subject across sections
  const isSubjectWiseNumbering = info && info.number_sequence == 3;
  const subjectCounters = {};

  function convertDate(dateStr) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Split the input date string
    const parts = dateStr.split("-");

    // Extract year, month, and day
    const year = parts[0];
    const month = months[parseInt(parts[1], 10) - 1];
    const day = parts[2];

    // Combine them into the desired format
    const date = `${year}-${month}-${day}`;
    return date.split("-").reverse().join("-");
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {/* <button onClick={() => console.log(quesData)}>dvsv</button> */}
          <table
            style={{
              width: "100%",
              maxWidth: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
            }}
            className="printable print-page print-solution"
          >
            <tbody style={{ marginBottom: "80px" }}>
              <tr>
                <td
                  className={`${styles.printContainer}  ${styles.headerContainer}`}
                  style={{ width: "100%" }}
                >
                  <>
                    <div className={styles.logoContainer}>
                      <img src={logo} />
                    </div>
                    <p className={styles.title}>
                      {
                        searchParams.get("key") === "0" || searchParams.get("key") === "1"
                          ? "Student's Solution Copy"
                          : searchParams.get("key") === "2"
                            ? "Paper Solution"
                            : "Teacher's Solution Copy"
                      }
                      {` [CODE - ${info.paper_id}]`}
                    </p>

                    <p className={styles.title}>{info.paper_name}</p>
                    <p className={styles.title}>
                      {`${info.class} ${info.target} - ${info.phase}`}
                    </p>
                    <p className={styles.title}>
                      {`${info.center}`}
                    </p>
                    {info.batch_name && (
                      <p className={styles.title}>{info.batch_name}</p>
                    )}
                    <div className={styles.paperDetail}>
                      <p className={styles.title}>Date: {info.to_be_held_on}</p>
                      <p className={styles.title}>Duration: {info.duration} </p>
                      <p className={styles.title}>
                        Max Marks:{" "}
                        {isEmpty(info.max_marks)
                          ? info.total_marks
                          : info.max_marks}
                      </p>
                    </div>
                    {/* Publish Solution(Student’s Copy) */}
                    <>
                      {subjectArr.map((sub) => (
                        <>
                          {sectionArr.map((sec, secIndex) => (
                            <>
                              {!isEmpty(
                                solutionData.filter(
                                  (x) =>
                                    x.subject == sub && x.section_name == sec
                                )
                              ) && (
                                  <>
                                    <div
                                      className={styles.section}
                                      key={uid(sec)}
                                    >
                                      <div className={styles.tableTitle}>
                                        <span>
                                          {`${searchParams.get("key") == 4 ? "" : `${sub} -`} ${sec}`}
                                        </span>
                                      </div>
                                      <div className={styles.sectionSeparator}></div>

                                      <>
                                        {searchParams.get("key") == 0 || searchParams.get("key") == 3 || searchParams.get("key") == 4 || searchParams.get("key") == 5 ? (
                                          <>
                                            {solutionData
                                              .filter(
                                                (x) =>
                                                  x.subject == sub &&
                                                  x.section_name == sec
                                              )
                                              .map((data) => {
                                                const nextNum = (subjectCounters[sub] = (subjectCounters[sub] || 0) + 1);
                                                const overrideData = isSubjectWiseNumbering ? { ...data, display_number: nextNum } : data;
                                                return (
                                                  <SolutionComponent
                                                    solutionData={overrideData}
                                                    pageKey={searchParams.get("key")}
                                                  />
                                                );
                                              })}
                                          </>
                                        ) : (
                                          <div className="row" style={{
                                            pageBreakInside: 'auto',
                                            breakInside: 'avoid',
                                          }}>
                                            <div className="col-12">
                                              <div
                                                className="solution-content"
                                                style={{
                                                  columnCount: 2,
                                                  columnGap: '40px',
                                                  pageBreakInside: 'auto',
                                                  breakInside: 'avoid-column'
                                                }}
                                              >
                                                {solutionData
                                                  .filter(
                                                    (x) =>
                                                      x.subject == sub &&
                                                      x.section_name == sec
                                                  )
                                                  .map((data) => {
                                                    const nextNum = (subjectCounters[sub] = (subjectCounters[sub] || 0) + 1);
                                                    const overrideData = isSubjectWiseNumbering ? { ...data, display_number: nextNum } : data;
                                                    return (
                                                      <SolutionComponent
                                                        solutionData={overrideData}
                                                        pageKey={searchParams.get("key")}
                                                      />
                                                    );
                                                  })}
                                              </div>
                                            </div>
                                          </div>

                                        )}
                                      </>
                                    </div>
                                  </>
                                )}
                            </>
                          ))}
                        </>
                      ))}
                    </>
                    {/* Publish Solution(Teacher’s Copy - English) */}
                    {/* {searchParams.get("key") == 1 && (
                      <>
                        {subjectArr.map((sub) => (
                          <>
                            {sectionArr.map((sec, secIndex) => (
                              <>
                                {!isEmpty(
                                  solutionData.filter(
                                    (x) =>
                                      x.subject == sub && x.section_name == sec
                                  )
                                ) && (
                                    <div
                                      className={styles.section}
                                      key={uid(sec)}
                                    >
                                      <div className={styles.tableTitle}>
                                        <span>
                                          {sub} - {sec}
                                        </span>
                                      </div>
                                      {solutionData
                                        .filter(
                                          (x) =>
                                            x.subject == sub &&
                                            x.section_name == sec
                                        )
                                        .map((data) => {
                                          const nextNum = (subjectCounters[sub] = (subjectCounters[sub] || 0) + 1);
                                          const overrideData = isSubjectWiseNumbering ? { ...data, display_number: nextNum } : data;
                                          return (
                                            <SolutionComponent
                                              solutionData={overrideData}
                                              pageKey={searchParams.get("key")}
                                            />
                                          );
                                        })}
                                    </div>
                                  )}
                              </>
                            ))}
                          </>
                        ))}
                      </>
                    )} */}
                    {/* Publish Solution(Teacher’s Copy - Hindi) */}
                  </>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div className={styles.footer}>

                    <img
                      src={footerImage}
                      alt="Footer"
                      style={{ width: "100%", height: "35px", }}
                    />
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </>
      )}
    </>
  );
};

export default Solution;
